// UltraFlex - Captcha Component
import React, { useState, useEffect, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CaptchaWidget = ({ onVerify }) => {
  const [question, setQuestion] = useState('');
  const [token, setToken] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchChallenge = useCallback(async () => {
    setLoading(true);
    setAnswer('');
    try {
      const res = await fetch(`${API_URL}/api/captcha/challenge`);
      const data = await res.json();
      setQuestion(data.question);
      setToken(data.token);
      onVerify('', data.token);
    } catch {
      setQuestion('Captcha unavailable');
    }
    setLoading(false);
  }, [onVerify]);

  useEffect(() => { fetchChallenge(); }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setAnswer(val);
    onVerify(val, token);
  };

  return (
    <div className="flex items-center gap-3 bg-zinc-800/50 border border-zinc-700 rounded-lg p-3" data-testid="captcha-widget">
      <div className="flex items-center gap-2 flex-1">
        <span className="text-uf-textMuted text-sm whitespace-nowrap">What is</span>
        <span className="text-white font-bold text-lg font-mono bg-zinc-900 px-3 py-1 rounded" data-testid="captcha-question">{question}</span>
        <span className="text-uf-textMuted text-sm">=</span>
        <input
          type="text"
          inputMode="numeric"
          value={answer}
          onChange={handleChange}
          placeholder="?"
          className="w-20 bg-zinc-900 border border-zinc-700 rounded px-3 py-1.5 text-white text-center font-mono text-lg focus:border-uf-red focus:outline-none"
          data-testid="captcha-answer"
          autoComplete="off"
        />
      </div>
      <button
        type="button"
        onClick={fetchChallenge}
        className="p-1.5 text-zinc-500 hover:text-white"
        title="New challenge"
        data-testid="captcha-refresh"
      >
        <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
      </button>
    </div>
  );
};

export default CaptchaWidget;
